import type { SVGProps } from 'react';
import type { SVGRType } from '../types';

const SvgHistory = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRType) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 24 24'
    width='24'
    height='24'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M4.54588 10.8678H5.54269C6.2143 7.53798 9.1906 5 12.6971 5C16.6985 5 20 8.30857 20 12.3029C20 16.3043 16.6985 19.6058 12.6971 19.6058C10.4066 19.6058 8.26448 18.4534 6.95661 16.7426C6.64554 16.3679 6.70917 15.9154 7.03437 15.6821C7.38078 15.4347 7.79082 15.5408 8.0736 15.873C9.14111 17.2728 10.8025 18.1636 12.6971 18.1706C15.9562 18.1777 18.5649 15.5549 18.5649 12.3029C18.5649 9.05087 15.9562 6.4422 12.6971 6.4422C9.93997 6.4422 7.64236 8.31564 7.01316 10.8678H8.03118C8.57554 10.8678 8.71693 11.2849 8.42001 11.6878L6.70917 14.0703C6.47587 14.3955 6.10826 14.4026 5.86789 14.0703L4.15705 11.6949C3.85306 11.2778 3.99445 10.8678 4.54588 10.8678ZM12.4285 8.08234C12.7961 8.08234 13.1001 8.37926 13.1001 8.74688V12.4938L14.7685 14.756C15.0159 15.1024 14.9947 15.5054 14.6766 15.7246C14.3302 15.9579 13.9484 15.8942 13.6656 15.5266L11.9548 13.2643C11.8134 13.0876 11.7639 12.925 11.7639 12.7553V8.74688C11.7639 8.37926 12.0609 8.08234 12.4285 8.08234Z' />
  </svg>
);

export default SvgHistory;
